import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { ClientProjectInfo, HMInventoryInfo } from "../../../SchemaInfo/info";
import LoadingPage from "../../../Components/layouts/loading";
import { ClientProjectSchema } from "../../../Schemas/clients/client_project_schema";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { HMInventorySchema } from "../../../Schemas/purchase/hm_inventory_schema";

const AddHMInvetory = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // const handelSubmit = (values) => {
  //   console.log("the values are", values);
  //   const formData = new FormData();
  //   for (let key in values) {
  //     if (values[key]) {
  //       formData.append(key, values[key]);
  //     }
  //   }

  //   const headers = { "Content-Type": "multipart/form-data" };

  //   setLoading(true);
  //   performRequest(
  //     "POST",
  //     "/materialPlanning/createHMInventory",
  //     formData,
  //     headers
  //   )
  //     .then((res) => {
  //       if (res.status === 201) {
  //         Toast("success", "Inventory created successfully!");
  //         navigate(`/hydroponic-material-inventory`);
  //       } else {
  //         Toast("error", "Error while creating inventory!");
  //       }
  //     })
  //     .catch((err) => {
  //       CustomErrorResponse(err);
  //     })
  //     .finally(() => setLoading(false));
  // };

  const fabricationProcessOptions = [
    { value: "repacking", label: "Repacking" },
    { value: "bending", label: "Bending" },
    { value: "punching", label: "punching" },
    { value: "holemaking", label: "Hole-Making" },
    { value: "cutting", label: "Cutting" },
    { value: "welding", label: "Welding" },
    { value: "painting", label: "Painting" },
    { value: "assembly", label: "Assembly" },
  ];
  const gstOptions = [
    { value: "0", label: "0" },
    { value: "5", label: "5" },
    { value: "12", label: "12" },
    { value: "18", label: "18" },
    { value: "28", label: "28" },
  ];

  const locationOptions = [
    { value: "decWarehouse", label: "DEC-Warehouse" },
    { value: "kryzenOffice", label: "Kryzen Office" },
  ];

  const handelSubmit = (values) => {
    const formData = new FormData();

    for (let key in values) {
      if (values[key]) {
        if (key === "image" && values[key] instanceof File) {
          // if it's a file input, append the file directly
          formData.append(key, values[key]);
        } else if (
          typeof values[key] === "object" &&
          !(values[key] instanceof File)
        ) {
          // for other objects except File, stringify
          formData.append(key, JSON.stringify(values[key]));
        } else {
          // for strings, numbers, or image URL string
          formData.append(key, values[key]);
        }
      }
    }

    const headers = { "Content-Type": "multipart/form-data" };

    setLoading(true);
    performRequest(
      "POST",
      "/materialPlanning/createHMInventory",
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Inventory created successfully!");
          navigate(`/hydroponic-material-inventory`);
        } else {
          Toast("error", "Error while creating inventory!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }
  const hydroponicOptions = [
    { value: "flatbed", label: "Flatbed" },
    { value: "growbags", label: "Grow-bags" },
    { value: "foggers", label: "Foggers" },
    { value: "cea", label: "CEA" },
    { value: "planters", label: "100 Planters" },
    { value: "dutch_bucket", label: "Dutch Bucket" },
    { value: "sikit", label: "Si Kit" },
    { value: "officeItems", label: "Office Items" },
    { value: "tools", label: "Tools And Machinery" },
    { value: "notdefined", label: "Not Defined" },
    { value: "adiAcc", label: "Additional Accessories" },
    {
      value: "fertilizer_self_consumption",
      label: "Fertilizers / Self Consumption",
    },
    {
      value: "hydroponic_raw_material",
      label: "Hydroponic - Raw Material",
    },
    {
      value: "cea_raw_material",
      label: "CEA - Raw Material",
    },
  ];
  const materialTypeOptions = [
    { value: "gi", label: "GI" },
    { value: "alumunium", label: "Alumunium" },
    { value: "stainless_steel", label: "Stainless Steel" },
    { value: "tmt_bar", label: "TMT Bar" },
    { value: "rubber", label: "Rubber" },
    { value: "hdpe_plastic", label: "HDPE Plastic" },
    { value: "food_grade_pipe", label: "Food Grade Pipe" },
    { value: "pvc", label: "PVC" },
    { value: "upvc", label: "UPVC" },
    { value: "net", label: "Net" },
    { value: "flim", label: "Film" },
    { value: "fertilizers", label: "Fertilizers" },
    { value: "otherItems", label: "Other Items" },
  ];

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">New Inventory</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">New Inventory</h2>
            </div>
            <Formik
              initialValues={HMInventoryInfo}
              validationSchema={HMInventorySchema}
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Item Name
                      </label>

                      <div className="w-100 col">
                        <CustomInput name="item" type="text" />
                        {props.touched.item && props.errors.item && (
                          <p className="text-danger">{props.errors.item}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label required">HSN</label>
                      <div className="w-100 col">
                        <CustomInput name="hsn" type="text" />
                        {props.touched.hsn && props.errors.hsn && (
                          <p className="text-danger">{props.errors.hsn}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Short Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="shortName" />
                        {props.touched.shortName && props.errors.shortName && (
                          <p className="text-danger">
                            {props.errors.shortName}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Measurement Unit
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="unit">
                          <option value="">Select</option>
                          <option value="nos">Nos</option>
                          <option value="kg">Kg</option>
                          <option value="grams">Grams</option>
                          <option value="ltr">Litter</option>
                          <option value="ml">ML</option>
                          <option value="packs">Packs</option>
                          <option value="pair">Pair</option>
                          <option value="sqm">SqM</option>
                          <option value="sqft">SqFt</option>
                          <option value="mtr">Meters</option>
                          {/* <option value="pcs">Pices</option> */}
                        </CustomSelect>

                        {props.touched.unit && props.errors.unit && (
                          <p className="text-danger">{props.errors.unit}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Product Unit
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="proUnit">
                          <option value="">Select</option>
                          <option value="nos">Nos</option>
                          <option value="kg">Kg</option>
                          <option value="grams">Grams</option>
                          <option value="ltr">Litter</option>
                          <option value="ml">ML</option>
                          <option value="packs">Packs</option>
                          <option value="pair">Pair</option>
                          <option value="sqm">SqM</option>
                          <option value="sqft">SqFt</option>
                          <option value="mtr">Meters</option>
                          {/* <option value="pcs">Pices</option> */}
                        </CustomSelect>

                        {props.touched.proUnit && props.errors.proUnit && (
                          <p className="text-danger">{props.errors.proUnit}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-3 form-label required text-capitalize ">
                        {`Cost Per ${props.values.proUnit || "Unit"}`}
                      </label>
                      <div className="col">
                        <CustomInput
                          name="cost"
                          type="text"
                          className="form-control"
                        />
                        {props.touched.cost && props.errors.cost && (
                          <p className="text-danger">{props.errors.cost}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="col-3 form-label">Weight</label>
                      <div className="col">
                        <div className="input-group">
                          <CustomInput
                            name="weight"
                            type="text"
                            step="0.01"
                            className="form-control"
                            placeholder="Enter weight"
                          />
                          {props.touched.weight && props.errors.weight && (
                            <p className="text-danger">{props.errors.weight}</p>
                          )}

                          <CustomSelect type="text" name="weight_unit">
                            <option value="">Select</option>
                            <option value="g">g</option>
                            <option value="oz">oz</option>
                            <option value="lb">lb</option>
                            <option value="nos">Nos</option>
                            <option value="kg">Kg</option>
                            <option value="grams">Grams</option>
                            <option value="ltr">Litter</option>
                            <option value="ml">ML</option>
                            <option value="packs">Packs</option>
                            <option value="pair">Pair</option>
                            <option value="sqm">SqM</option>
                            <option value="sqft">SqFt</option>
                            <option value="mtr">Meters</option>
                          </CustomSelect>
                          {props.touched.weight_unit &&
                            props.errors.weight_unit && (
                              <p className="text-danger">
                                {props.errors.weight_unit}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 col-form-label col-3">
                        Technical Specification
                      </label>
                      <div className="w-100 col">
                        <textarea
                          name="productSpecification"
                          className="form-control"
                          placeholder="Enter technical specification"
                          rows={3}
                          value={props.values.productSpecification} // bind value
                          onChange={props.handleChange} // update Formik state
                          onBlur={props.handleBlur} // mark as touched for validation
                        />

                        {props.touched.productSpecification &&
                          props.errors.productSpecification && (
                            <p className="text-danger mt-1">
                              {props.errors.productSpecification}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Brand Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="brandName" />
                        {props.touched.brandName && props.errors.brandName && (
                          <p className="text-danger">
                            {props.errors.brandName}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Size
                      </label>
                      <div className="w-100 col">
                        <CustomSelect type="text" name="size">
                          <option value="">Select</option>
                          <option value="Small">200g - 1kg (Small)</option>
                          <option value="Medium">1kg - 10kg (Medium)</option>
                          <option value="Large">10kg - 20kg (Large)</option>
                          <option value="Extra Large">
                            20kg - 50kg (Extra Large)
                          </option>
                          <option value="Double Extra Large">
                            50kg - 100kg (Double Extra Large)
                          </option>
                          <option value="Other">Other</option>
                        </CustomSelect>

                        {props.touched.size && props.errors.size && (
                          <p className="text-danger">{props.errors.size}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Usage Type
                      </label>
                      <div className="w-100 col d-flex flex-wrap">
                        {hydroponicOptions?.map((type) => {
                          const isChecked =
                            props?.values?.hydroponicTypeNew?.includes(
                              type?.value
                            );
                          return (
                            <div className="form-check me-3" key={type?.value}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={type?.value}
                                name="hydroponicTypeNew"
                                checked={isChecked}
                                onChange={(e) => {
                                  const selected = [
                                    ...props?.values?.hydroponicTypeNew,
                                  ];
                                  const specs = [
                                    ...props?.values?.specificationsNew,
                                  ];

                                  if (e.target?.checked) {
                                    selected.push(type?.value);
                                    specs.push({
                                      type: type?.value,
                                      specification: "",
                                    });
                                  } else {
                                    const index = selected.indexOf(type?.value);
                                    if (index > -1) selected.splice(index, 1);
                                    const specIndex = specs.findIndex(
                                      (item) => item?.type === type?.value
                                    );
                                    if (specIndex > -1)
                                      specs.splice(specIndex, 1);
                                  }

                                  props.setFieldValue(
                                    "hydroponicTypeNew",
                                    selected
                                  );
                                  props.setFieldValue(
                                    "specificationsNew",
                                    specs
                                  );
                                }}
                                onBlur={props.handleBlur}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={type.value}
                              >
                                {type.label}
                              </label>
                            </div>
                          );
                        })}

                        {props?.touched?.hydroponicTypeNew &&
                          props?.errors?.hydroponicTypeNew && (
                            <p className="text-danger w-100">
                              {props?.errors?.hydroponicTypeNew}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      {props.values.specificationsNew.map((item, index) => (
                        <React.Fragment key={item.type}>
                          <label className="col-3 form-label text-capitalize">
                            {`${props.values.item} Description in ${
                              item.type.charAt(0).toUpperCase() +
                              item.type.slice(1)
                            } `}
                          </label>
                          <div className="col-9 mb-3">
                            <textarea
                              type="text"
                              className="form-control"
                              value={item.specification}
                              onChange={(e) => {
                                const updated = [
                                  ...props.values.specificationsNew,
                                ];
                                updated[index].specification = e.target.value;
                                props.setFieldValue(
                                  "specificationsNew",
                                  updated
                                );
                              }}
                            />
                          </div>
                        </React.Fragment>
                      ))}
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Material Type
                      </label>
                      <div className="w-100 col">
                        <select
                          className="form-select"
                          name="materialType"
                          value={props.values.materialType || ""}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        >
                          <option value="">Select Material Type</option>
                          {materialTypeOptions.map((type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </select>

                        {props.touched.materialType &&
                          props.errors.materialType && (
                            <p className="text-danger">
                              {props.errors.materialType}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">Image</label>
                      <div className="w-100 col">
                        <CustomInput
                          type="file"
                          name="image"
                          onChange={(e) =>
                            props.setFieldValue("image", e.target.files[0])
                          }
                        />
                        {props.touched.image && props.errors.image && (
                          <p className="text-danger">{props.errors.image}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">In stock</label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="inStock" />
                        {props.touched.inStock && props.errors.inStock && (
                          <p className="text-danger">{props.errors.inStock}</p>
                        )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Threshold limit
                      </label>

                      <div className="w-100 col">
                        <CustomInput type="text" name="thresholdLimit" />

                        {props.touched.thresholdLimit &&
                          props.errors.thresholdLimit && (
                            <p className="text-danger">
                              {props.errors.thresholdLimit}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row mt-3">
                      <label className="w-25 form-label col-3 required">
                        Location
                      </label>
                      <div className="w-100 col d-flex flex-wrap">
                        {locationOptions.map((type) => {
                          const isChecked = props?.values?.location
                            ? props?.values?.location === type?.value
                            : type?.value === "decWarehouse"; // default if empty

                          return (
                            <div className="form-check me-3" key={type?.value}>
                              <input
                                type="radio"
                                className="form-check-input"
                                id={type.value}
                                name="location"
                                value={type.value}
                                checked={isChecked}
                                onChange={() => {
                                  props.setFieldValue("location", type.value);
                                }}
                                onBlur={props.handleBlur}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={type?.value}
                              >
                                {type?.label}
                              </label>
                            </div>
                          );
                        })}

                        {props.touched.location && props.errors.location && (
                          <p className="text-danger w-100">
                            {props.errors.location}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">Rack Id</label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="rackId" />

                        {props.touched.rackId && props.errors.rackId && (
                          <p className="text-danger">{props.errors.rackId}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Si Kit / Planter / Dutchbucket Count
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="count" />
                        {props.touched.count && props.errors.count && (
                          <p className="text-danger">{props.errors.count}</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Is Item in List
                      </label>
                      <div className="w-100 col">
                        <CustomCheckbox
                          name="iteminList"
                          type="checkbox"
                          height={"20px"}
                          width={"20px"}
                        ></CustomCheckbox>
                        {props.touched.iteminList &&
                          props.errors.iteminList && (
                            <p className="text-danger">
                              {props.errors.iteminList}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row ">
                      <label className="w-25 form-label col-3">
                        Need transportation
                      </label>
                      <div className="w-100 col ">
                        <CustomCheckbox
                          width={"20px"}
                          height={"20px"}
                          name="needTransportation"
                        />
                        {props.touched.needTransportation &&
                          props.errors.needTransportation && (
                            <p className="text-danger">
                              {props.errors.needTransportation}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Need packaging
                      </label>
                      <div className="w-100 col">
                        <CustomCheckbox
                          width={"20px"}
                          height={"20px"}
                          name="needPackaging"
                        />

                        {props.touched.needPackaging &&
                          props.errors.needPackaging && (
                            <p className="text-danger">
                              {props.errors.needPackaging}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Is fragile
                      </label>

                      <div className="w-100 col">
                        <CustomCheckbox
                          width={"20px"}
                          height={"20px"}
                          name="isFragile"
                        />
                        {props.touched.isFragile && props.errors.isFragile && (
                          <p className="text-danger">
                            {props.errors.isFragile}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Fabrication Charges Markup Percentage
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="fabricationChargesMarkup"
                          placeholder="default  is 3%"
                        />
                        {props.touched.fabricationChargesMarkup &&
                          props.errors.fabricationChargesMarkup && (
                            <p className="text-danger">
                              {props.errors.fabricationChargesMarkup}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Handling Charges Percentage
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="handlingCharges"
                          placeholder="default is 2.5%"
                        />
                        {props.touched.handlingCharges &&
                          props.errors.handlingCharges && (
                            <p className="text-danger">
                              {props.errors.handlingCharges}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Optional Warranty Coverge Per Unit
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="optionalWarrantyCovergePerUnit"
                          placeholder="default is 1"
                        />
                        {props.touched.optionalWarrantyCovergePerUnit &&
                          props.errors.optionalWarrantyCovergePerUnit && (
                            <p className="text-danger">
                              {props.errors.optionalWarrantyCovergePerUnit}
                            </p>
                          )}
                      </div>

                      <div className="mb-3 row mt-3">
                        <label className="w-25 form-label col-3 required">
                          GST Percentage
                        </label>
                        <div className="w-100 col d-flex flex-wrap">
                          {gstOptions.map((type) => {
                            const isChecked =
                              props?.values?.gst === type?.value;
                            return (
                              <div
                                className="form-check me-3"
                                key={type?.value}
                              >
                                <input
                                  type="radio"
                                  className="form-check-input"
                                  id={type.value}
                                  name="gst"
                                  value={type.value}
                                  checked={isChecked}
                                  onChange={() => {
                                    props.setFieldValue("gst", type.value);
                                  }}
                                  onBlur={props.handleBlur}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={type?.value}
                                >
                                  {type?.label}
                                </label>
                              </div>
                            );
                          })}

                          {props.touched.gst && props.errors.gst && (
                            <p className="text-danger w-100">
                              {props.errors.gst}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Fabrication Process
                      </label>
                      <div className="w-100 col d-flex flex-wrap">
                        {fabricationProcessOptions.map((type) => {
                          // const isChecked =
                          //   props?.values?.fabricationProcess?.includes(
                          //     type?.value
                          //   );
                          const isChecked =
                            props?.values?.fabricationProcess?.includes(
                              type.value
                            ) ?? false;

                          return (
                            <div className="form-check me-3" key={type?.value}>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={type?.value}
                                name="fabricationProcess"
                                checked={isChecked}
                                onChange={(e) => {
                                  const selected = [
                                    ...props?.values?.fabricationProcess,
                                  ];

                                  if (e.target.checked) {
                                    selected?.push(type?.value);
                                  } else {
                                    const index = selected.indexOf(type.value);
                                    if (index > -1) selected.splice(index, 1);
                                    // const specIndex = specs.findIndex(
                                    //   (item) => item.type === type.value
                                    // );
                                    // if (specIndex > -1)
                                    //   specs.splice(specIndex, 1);
                                  }

                                  props.setFieldValue(
                                    "fabricationProcess",
                                    selected
                                  );
                                  // props.setFieldValue(
                                  //   "specificationsNew",
                                  //   specs
                                  // );
                                }}
                                onBlur={props.handleBlur}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={type?.value}
                              >
                                {type?.label}
                              </label>
                            </div>
                          );
                        })}

                        {props.touched.fabricationProcess &&
                          props.errors.fabricationProcess && (
                            <p className="text-danger w-100">
                              {props.errors.fabricationProcess}
                            </p>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create Inventory" />

                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};
export default AddHMInvetory;
